export default __webpack_public_path__ + "static/travelImage-41d7f43dbd9a057e581590c76893f396.webp";